<template>
    <v-card flat class="mt-3 pa-1" v-if="companies">
        <v-form ref="form">

                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-text-field
                                class="pa-3"
                                v-model="regNr"
                                label="Reģistrācijas Nr."
                                color="deep-purple accent-3"
                                :rules="formRules"
                                required>
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 md4>
                        <v-text-field
                                class="pa-3"
                                v-model="year"
                                label="Ražošanas gads"
                                color="deep-purple accent-3"
                        >
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 md4>
                        <v-autocomplete
                                clearable
                                class="pa-3"
                                v-model="owner"
                                color="deep-purple accent-3"
                                item-text="name"
                                item-value="id"
                                :items="companies"
                                label="Īpašnieks"
                        ></v-autocomplete>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 md6>
                        <v-text-field
                                class="pa-3"
                                v-model="manufacturer"
                                label="Ražotājs"
                                color="deep-purple accent-3"
                        >
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-text-field
                                class="pa-3"
                                v-model="model"
                                label="Modelis"
                                color="deep-purple accent-3"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>

            <v-layout row wrap>
                <v-flex xs12 class=" mb-3">
                    <div class="text-xs-center text-md-right">
                        <v-btn small flat @click="hideModal" dark color="deep-orange lighten-1">
                            <v-icon dark left>block</v-icon>Atcelt</v-btn>
                        <v-btn small flat @click="submit" dark color="green accent-4">Pievienot
                            <v-icon dark right>check_circle</v-icon>
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>

</template>

<script>

    export default {
        name: "add-vehicle-modal",
        props: ['companies', 'vehicleType'],
        data: () => ({
            owner: '',
            regNr: '',
            year: '',
            manufacturer: '',
            model: '',
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        methods: {
            hideModal(){
                this.$store.dispatch('hideAllModals')
            },
            submit() {
                this.$Progress.start()
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('createNewVehicleFromModal', {
                        regNr: this.regNr,
                        ownerId: this.owner,
                        year: this.year,
                        manufacturer: this.manufacturer,
                        model: this.model,
                        typeId: this.vehicleType,
                    })
                } else {
                    this.$Progress.fail()
                }
            }
        }
    }
</script>

<style scoped>

</style>